export const TICKETS_PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const

export type TicketsPageSizeOption = (typeof TICKETS_PAGE_SIZE_OPTIONS)[number]

export const TICKETS_PAGE_SIZE_DEFAULT: TicketsPageSizeOption = 20

export function isTicketsPageSizeOption(n: number): n is TicketsPageSizeOption {
  return (TICKETS_PAGE_SIZE_OPTIONS as readonly number[]).includes(n)
}

export function parseTicketsPageSize(searchParams: URLSearchParams): TicketsPageSizeOption {
  const raw = searchParams.get('page_size')
  const n = raw ? parseInt(raw, 10) : NaN
  if (isTicketsPageSizeOption(n)) return n
  return TICKETS_PAGE_SIZE_DEFAULT
}
